// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3V54a","topBottomGutter":"Layout_topBottomGutter__23N6j"};